import clsx from 'clsx'
import React from 'react'
import ScrollTo from 'react-scroll-into-view'
import { useTranslate } from '../../contexts/TranslationContext'
import SvgChevronDown from '../../svg/icons/ChevronDown'
import { Button } from './Button'
import style from './ShowMoreLessButton.module.sass'

type ShowMoreLessButtonProps = {
	moreIsVisible: boolean
	onClick: () => void
	anchorId: string
}

export const ShowMoreLessButton = React.memo(function ShowMoreLessButton(props: ShowMoreLessButtonProps) {
	const translate = useTranslate()

	return (
		<ScrollTo selector={`#${props.anchorId}`}>
			<Button
				type={{ variant: 'nakedMore' }}
				label={props.moreIsVisible ? translate('button.more') : translate('button.less')}
				iconAfter={
					<span className={clsx(style.buttonIcon, !props.moreIsVisible && style.buttonIconUp)}>
						<SvgChevronDown />
					</span>
				}
				icon={{ fillPrimary: true }}
				onClick={props.onClick}
			/>
		</ScrollTo>
	)
})
